module.exports = __webpack_public_path__ + "app-static/img/ygq.ed768b1a.png";